var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33529 2.62772C1.54722 2.26539 2.74357 0.96648 3.59127 1.00066C3.85312 1.03744 4.09442 1.16293 4.27491 1.35617C4.92593 2.04795 5.49272 2.81438 5.96347 3.63948C6.12754 4.43933 5.1773 4.89737 5.46443 5.69038C5.80355 6.56211 6.32021 7.35381 6.98161 8.01522C7.64302 8.67662 8.43472 9.19328 9.30645 9.5324C10.1063 9.81953 10.5712 8.84878 11.3573 9.03337C12.184 9.5018 12.9507 10.0688 13.6407 10.722C13.8323 10.9028 13.9555 11.1443 13.9894 11.4056C14.0235 12.3012 12.6221 13.5112 12.3691 13.6616C11.7333 14.1196 10.9061 14.1059 9.89436 13.6616C7.07095 12.4857 2.55898 8.06263 1.36262 5.12984C0.897748 4.09755 0.870418 3.25666 1.33529 2.62772Z",
    stroke: "#858C9B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24512 1.17163C10.4641 1.3165 11.5989 1.86724 12.4669 2.73526C13.3349 3.60328 13.8857 4.73809 14.0306 5.95707",
    stroke: "#858C9B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24512 3.59851C9.83717 3.71305 10.3814 4.00215 10.8078 4.42856C11.2342 4.85497 11.5233 5.39918 11.6378 5.99123",
    stroke: "#858C9B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.aa4e67556c457cef3772380bc24b98da.svg";
export { ForwardRef as ReactComponent };